// extracted by mini-css-extract-plugin
export default {"coaches":"ClubCoaches_coaches__9kayk","name":"ClubCoaches_name__dhKFD"};